import React from 'react'
import { Flex } from '@chakra-ui/layout'
import InputFloating from '../../../components/InputFloating'
import { Button } from '@chakra-ui/button'
import { Table, TableContainer, Tbody, Thead, Tr } from '@chakra-ui/table'
import { Td, Th } from '../ResumoProducao/styles'
import { usePdfGenerator } from '../../../hooks/usePdfGenerator'
import { baseURL } from '../../../services/api'
import { Row } from './Row'
import { useForm } from 'react-hook-form'
import { Select } from '@chakra-ui/select'
import { Divider, Stat, StatLabel, Text, StatNumber, Icon, Box } from '@chakra-ui/react'
import { user } from '../../../helpers/user'
import { formatPrice } from '../../../utils/formatPrice'
import axios from 'axios'
import { useFilterDataOderBy } from '../../../hooks/useFilterDataOderBy'
import { AiOutlineArrowDown } from 'react-icons/ai'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { format } from 'date-fns'
import { useVendedoresMensal } from '../../../hooks/useVendedoresMensal'
import { permissoesUsuariosPropostas } from '../../../utils/permissoesUsuariosProposta'
import { BsPrinter } from 'react-icons/bs'

export function Expedicao() {
  const [data, setData] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [proximoPasso, setProximoPasso] = React.useState([])
  const [passoAtual, setPassoAtual] = React.useState([])
  const [itensFaltantes, setItensFaltantes] = React.useState([])
  const [searchParams] = useSearchParams()
  const { customers } = useVendedoresMensal()
  const history = useNavigate()

  const { register, handleSubmit } = useForm({})

  const { codigo_usuario: usuario } = user

  const codVend = searchParams.get('codVend')

  const isVendedor = !!codVend

  //transforma a variavel expedicao que é um numero em data para ordenar

  const { filteredData, newerOrOlder, setNewerOrOlder } = useFilterDataOderBy(
    data?.map((item) => {
      return {
        ...item,
        orderedBy: new Date().setDate(new Date().getDate() + item.expedicao),
      }
    }),
    'orderedBy'
  )

  const permissionCod = [21, 30]

  function firstLetterUpper(string) {
    return string?.length > 15
      ? string?.charAt(0).toUpperCase() + string?.slice(1).toLowerCase().substring(0, 15) + '...'
      : string?.charAt(0).toUpperCase() + string?.slice(1).toLowerCase()
  }

  async function getDadaResumoProduction(data) {
    setLoading(true)

    const requestOne = baseURL.get('/pedido/listar-info-tela-expedicao')
    const requestTwo = baseURL.post('/pedido/resumo-producao', {
      data_saida: '',
      data_entrada: '',
    })

    axios
      .all([requestOne, requestTwo])
      .then(
        axios.spread((responseOne, responseTwo) => {
          console.log(responseOne)
          let dateOrder = responseOne.data?.sort((a, b) => {
            //ordena por limite_producao (data)
            return b.expedicao - a.expedicao
          })

          if (codVend && codVend !== '0' && codVend !== '8') {
            dateOrder = dateOrder.filter((item) => item.codigo_vendedor === codVend)
          }

          setItensFaltantes(responseTwo.data?.lista)

          const newItems = dateOrder.map((item) => {
            const verifyStep = item?.contador_pedidos !== item?.contador_tela
            return {
              ...item,
              passo_atual: !verifyStep ? item.passo_atual : 'Falta item',
              proximo_passo: !verifyStep ? item.proximo_passo : 'Falta item',
              data_saida: item.data_saida ? format(new Date(item.data_saida), 'dd/MM/yyyy HH:mm') : '',
            }
          })

          if (data?.numero_pedido) {
            const filteredPedidos = newItems?.filter((item) => item.numero_pedido === data?.numero_pedido)
            setData(filteredPedidos)
          } else if (data?.data_inicio || data?.data_fim) {
            let filteredDataInicio = newItems

            if (data.data_inicio) {
              const dataInicio = new Date(data.data_inicio)
              dataInicio.setUTCHours(0, 0, 0, 0)

              filteredDataInicio = filteredDataInicio.filter((item) => {
                const itemDate = new Date(item.limite_producao)
                itemDate.setUTCHours(0, 0, 0, 0)
                return itemDate.getTime() >= dataInicio.getTime()
              })
            }

            if (data.data_fim) {
              const dataFim = new Date(data.data_fim)
              dataFim.setUTCHours(23, 59, 59, 999)

              filteredDataInicio = filteredDataInicio.filter((item) => {
                const itemDate = new Date(item.limite_producao)
                itemDate.setUTCHours(0, 0, 0, 0)
                return itemDate.getTime() <= dataFim.getTime()
              })
            }

            setData(filteredDataInicio)
          } else if (data?.proximo_passo && !data?.entrega) {
            const filteredProximoPasso = newItems?.filter((item) => item.proximo_passo === data.proximo_passo)
            setData(filteredProximoPasso)
          } else if (data?.passo_atual && !data?.entrega) {
            const filteredProximoPasso = newItems?.filter((item) => item.passo_atual === data.passo_atual)
            setData(filteredProximoPasso)
          } else if (data?.entrega && !data?.proximo_passo && !data?.passo_atual) {
            const filteredProximoPasso = newItems?.filter((item) => item.entrega.toLowerCase().includes(data.entrega.toLowerCase()))
            setData(filteredProximoPasso)
          } else if (data?.proximo_passo && data?.entrega) {
            const filteredProximoPasso = newItems?.filter(
              (item) => item.proximo_passo === data.proximo_passo && item.entrega.toLowerCase().includes(data.entrega.toLowerCase())
            )

            setData(filteredProximoPasso)
          } else if (data?.passo_atual && data?.entrega) {
            const filteredProximoPasso = newItems?.filter(
              (item) => item.passo_atual === data.passo_atual && item.entrega.toLowerCase().includes(data.entrega.toLowerCase())
            )
            setData(filteredProximoPasso)
          } else {
            setData(newItems)
          }

          const arrayProximoPasso = responseOne.data.map((item) => item.proximo_passo)
          const uniqueProximoPasso = [...new Set(arrayProximoPasso)]
          const arrayPassoAtual = responseOne.data.map((item) => item.passo_atual)
          const uniquePassoAtual = [...new Set(arrayPassoAtual)]

          setPassoAtual(uniquePassoAtual)

          setProximoPasso(uniqueProximoPasso)

          setLoading(false)
        })
      )
      .catch((error) => {
        // tratamento de erros
      })
  }

  const headData = [
    'Pedido',
    'Código',
    'Descrição',
    'Cor',
    'Quantidade',
    'Passo atual',
    'Próximo passo',
    'Prazo',
    'Material pronto',
    `${!isVendedor ? 'Limite de produção' : 'Data de Saída'}`,
    'Expedição a',
    'Entrega',
  ]

  const mapBodyData = () => {
    return data.map((item) => [
      item.numero_pedido,
      item.codigo_produto,
      firstLetterUpper(item.descricao_produto),
      firstLetterUpper(item.cor),
      item.quantidade_negociada,
      firstLetterUpper(item.passo_atual),
      firstLetterUpper(item.proximo_passo),
      item.prazo_entrega + ' dias',
      item.dt_material_pronto,
      isVendedor ? item.data_saida : item.limite_producao,
      item.expedicao + ' dias',
      firstLetterUpper(item.entrega),
    ])
  }

  const generatePDF = usePdfGenerator(headData, mapBodyData, 'Expedição')

  React.useEffect(() => {
    getDadaResumoProduction()
  }, [])

  React.useEffect(() => {
    if (codVend) {
      getDadaResumoProduction()
    }
  }, [codVend])

  const dataSemDuplicados = data?.filter((item, index, self) => self.findIndex((t) => t.numero_pedido === item.numero_pedido) === index)

  const filteredItems = dataSemDuplicados.filter((item) => item.contador_pedidos === item.contador_tela)

  const restanteItems = dataSemDuplicados.filter((item) => item.contador_pedidos !== item.contador_tela)

  const summary = restanteItems.reduce((acc, item) => {
    const { valor_pedido } = item

    const valorTotal = acc + parseFloat(valor_pedido)

    return valorTotal
  }, 0)

  function handleOrderBy() {
    setNewerOrOlder(newerOrOlder === 'newer' ? 'older' : 'newer')
  }

  const [orderByLimit, setOrderByLimit] = React.useState('desc')

  function orderBy({ column, direction }) {
    const sortedData = [...data].sort((a, b) => {
      if (column === 'PEDIDO' || column === 'CODIGO') {
        return a[column] - b[column]
      }

      setOrderByLimit('desc')
      return a[column].localeCompare(b[column])
    })

    if (direction === 'desc') {
      sortedData.reverse()
      setOrderByLimit('asc')
    }

    setData(sortedData)
  }

  //&& user?.codigo_vendedor !== '0'
  if (
    user?.codigo_vendedor !== '0' &&
    user?.codigo_vendedor !== '8' &&
    //ana cod vend 10
    user?.codigo_vendedor !== codVend
  ) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh" fontSize="1.5rem" fontWeight="bold">
        Você não tem permissão para acessar essa página
      </Flex>
    )
  }
  //create counter pedidos
  const pedidos = data?.map((item) => item.numero_pedido)

  return (
    <>
      <Flex w="full" alignItems="center" gap={2} position="relative" justifyContent="center" mx="auto">
        {permissoesUsuariosPropostas[user?.codigo_usuario] && (
          <Select
            ml={2}
            maxW="347px"
            w="full"
            minH="51px"
            borderRadius="0"
            m="0"
            value={codVend}
            onChange={(e) => {
              history(`/expedicao?codVend=${e.target.value}`)
            }}
          >
            <option value="">Selecione um vendedor</option>
            <option value="0">Todos</option>
            {customers?.map((customer) => (
              <option key={customer.codigo_usuario} value={customer.codvend}>
                {customer.apelido}
              </option>
            ))}
          </Select>
        )}
        <Box paddingBlock="14px" bg={'#378BBF'} textAlign="center" fontSize="16px" color="white" fontWeight="bold" w="full">
          <Text mr={user?.codigo_usuario === 30 && '420px'}>Expedição</Text>
        </Box>
      </Flex>
      <Flex
        marginBlock="1.5rem"
        maxW="1150px"
        marginInline="auto"
        justifyContent="space-between"
        gap={2}
        onSubmit={handleSubmit(getDadaResumoProduction)}
        as="form"
      >
        <InputFloating label="Número pedido" type="number" {...register('numero_pedido')} />
        <InputFloating label="Data de entrada" type="date" {...register('data_inicio')} />
        <InputFloating label="Data de saída" type="date" {...register('data_fim')} />
        <Select placeholder="Passo atual" {...register('passo_atual')}>
          <option value="">Todos</option>
          <option value={'Falta item'}>Falta item</option>
          {passoAtual.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </Select>
        <Select placeholder="Próximo passo" {...register('proximo_passo')}>
          <option value="">Todos</option>
          <option value={'falta'}>Falta item</option>
          {proximoPasso.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </Select>
        <Select placeholder="Entrega" {...register('entrega')}>
          <option value="">Todos</option>
          <option value="Nosso carro">Nosso carro</option>
          <option value="Transportadora">Transportadora</option>
          <option value="Cliente retira">Cliente retira</option>
          <option value="MotoBoy">MotoBoy</option>
        </Select>

        <Button Button variant="ghost" colorScheme="blue" type="submit">
          Buscar
        </Button>
      </Flex>
      <Flex alignItems={'center'} justifyContent={'space-between'} paddingRight={'1rem'} mb={'1rem'}>
        <Button onClick={() => generatePDF(data.lista)} variant="ghost" colorScheme="blue">
          Download PDF
        </Button>
        {/*<Modal data={data} loading={loading} />*/}
        <Flex gap={2} height={'30px'} alignItems={'center'} justifyContent={'space-between'}>
          <Text color="blue.500" fontWeight="bold">
            Pedidos: {pedidos?.length}
          </Text>
          <Divider orientation="vertical" />
          <Text color="blue.500" fontWeight="bold">
            Nosso carro: {filteredItems?.filter((item) => item.entrega.toLowerCase().includes('nosso carro')).length}
          </Text>
          <Divider orientation="vertical" />
          <Text color="blue.500" fontWeight="bold">
            Transportadora: {filteredItems?.filter((item) => item.entrega.toLowerCase().includes('transportadora')).length}
          </Text>
          <Divider orientation="vertical" />
          <Text color="blue.500" fontWeight="bold">
            Cliente retira: {filteredItems?.filter((item) => item.entrega.toLowerCase().includes('cliente retira')).length}
          </Text>
          <Divider orientation="vertical" />
          <Text color="blue.500" fontWeight="bold">
            Total: {filteredItems?.length}
          </Text>
          <Divider orientation="vertical" />
          <Stat borderRadius="md" padding="0.5rem" boxShadow="md">
            <StatLabel color="red.500" fontWeight="bold">
              Faltam: {restanteItems.length}
            </StatLabel>
            <Divider orientation="vertical" />
            {permissionCod.includes(usuario) && (
              <>
                <StatNumber fontSize="1rem">{formatPrice(summary)}</StatNumber>
              </>
            )}
          </Stat>
        </Flex>
      </Flex>
      <TableContainer maxW="100%" overflowX="auto" height="calc(100vh - 20rem)" overflowY="auto">
        <Table size="sm" variant="striped">
          <Thead position="sticky" top="0" bg="#378BBF" zIndex="1">
            <Tr>
              <Th color="white">Pedido</Th>
              <Th color="white">Obs</Th>
              <Th color="white">Codigo</Th>
              <Th color="white">Itens</Th>
              <Th color="white">Descrição</Th>
              <Th color="white">Cor</Th>
              <Th color="white">Quantidade</Th>
              <Th color="white">Passo atual</Th>
              <Th color="white">Próximo passo</Th>
              <Th color="white">Prazo</Th>
              <Th color="white">Material pronto</Th>
              {!isVendedor && (
                <Th color="white">
                  <Flex gap={2} alignItems="center">
                    Limite de produção
                    <Icon
                      as={AiOutlineArrowDown}
                      onClick={() => orderBy({ column: 'limite_producao', direction: orderByLimit })}
                      transition="0.3s"
                      transform={orderByLimit === 'asc' ? 'rotate(180deg)' : 'rotate(0deg)'}
                      cursor="pointer"
                      fontSize="1.3rem"
                    />
                  </Flex>
                </Th>
              )}
              {isVendedor && <Th color="white">Data de Saída</Th>}
              <Th color="white">
                <Flex gap={2} alignItems="center">
                  Expedição a
                  <Icon
                    as={AiOutlineArrowDown}
                    onClick={handleOrderBy}
                    transition="0.3s"
                    transform={newerOrOlder === 'newer' ? 'rotate(180deg)' : 'rotate(0deg)'}
                    cursor="pointer"
                    fontSize="1.3rem"
                  />
                </Flex>
              </Th>
              <Th color="white">Entrega</Th>

              <Th color="white">
                <Flex alignItems="center" justifyContent="center" gap={2}>
                  <BsPrinter size="25px" color="#fff" />
                  Imprimir
                </Flex>
              </Th>
            </Tr>
          </Thead>
          {loading && (
            <Tbody>
              <Tr>
                <Td colSpan="15">Carregando...</Td>
              </Tr>
            </Tbody>
          )}
          {!loading && data.lista?.length === 0 && (
            <Tbody>
              <Tr>
                <Td colSpan="15">Nenhum registro encontrado</Td>
              </Tr>
            </Tbody>
          )}
          {!loading && (
            <Tbody>
              {filteredData?.map((items, index) => {
                return (
                  <Row
                    key={index}
                    item={items}
                    index={index}
                    itensFaltantes={itensFaltantes?.filter((item) => item.PEDIDO === items.numero_pedido)}
                    isVendedor={isVendedor}
                  />
                )
              })}
            </Tbody>
          )}
        </Table>
      </TableContainer>
    </>
  )
}
